import * as types from "./../types";

const state = {
  secure: false
};

const getters = {
  [types.secure.getters.GET_SECURE]: state => {
    return state.secure;
  }
};

const mutations = {
  [types.secure.mutations.MUTATE_SECURE]: (state, payload) => {
    state.secure = payload;
  }
};

const actions = {
  [types.secure.actions.SET_SECURE]: ({ commit }, payload) => {
    commit(types.secure.mutations.MUTATE_SECURE, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
